import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '../../../modules';

import {
  ContainerGrid,
  ContentsLayout,
  ItemGrid,
} from '../../../components/UIComponents/Layout/DefaultLayout';
import Input from '../../../components/UIComponents/Input/Input';
import {
  getConfirmPasswordAsync,
  GET_CONFIRM_PASSWORD,
} from '../../../modules/myPage';
import { GetConfirmPasswordParamType } from '../../../api/myPage/type';
import Spinner from '../../../components/UIComponents/Spinner';
import Header from '../../../components/Organisms/Header';

const WarningMessage = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  line-height: normal;
  color: ${(props) => props.theme.colors.grey800};
  display: flex;
  flex-direction: column;
  height: 45px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 516px;
  margin-top: 40px;
`;

const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
  &:nth-child(2) {
    margin-bottom: 80px;
  }
  &:last-child {
    margin-bottom: 0px;
  }
`;

const FormItemTitle = styled.div`
  font-family: 'RobotoB', 'NotoKrB';
  font-size: 14px;
  line-height: normal;
  color: ${(props) => props.theme.colors.grey800};
  margin-bottom: 8px;
`;

const FormButton = styled.button`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 16px;
  line-height: normal;
  color: white;
  width: 100%;
  height: 55px;
  border-radius: 8px;
  background-color: #333333;
  border: none;
  cursor: pointer;
`;

const FormInputWrapper = styled.div`
  width: 100%;
  height: 56px;
`;

const SpinnerWrapper = styled.div`
  width: 100%;
  height: 24px;
`;

const ConfirmPassword = () => {
  const loading = useSelector((state: RootState) => state.loading);
  const { userId } = useSelector((state: RootState) => state.authentication);
  const dispatch = useDispatch();

  const onGetConfirmPassword = (info: GetConfirmPasswordParamType) => {
    dispatch(getConfirmPasswordAsync.request(info));
  };

  const [password, setPassword] = useState('');
  const onClickSubmitButton = () => {
    onGetConfirmPassword({
      password,
    });
  };

  const onChangePassword = (value: string) => {
    setPassword(value);
  };

  return (
    <ContentsLayout>
      <Header title="비밀번호 확인" isDatePicker={false} />
      <ContainerGrid>
        <ItemGrid $desktop={12}>
          <WarningMessage>
            <div>
              회원님의 소중한 개인정보 보호를 위해 비밀번호를 한번 더 확인하고
              있습니다.
            </div>
            <div>
              공공장소에서 PC를 사용중일 경우, 비밀번호가 타인에게 노출되지
              않도록 주의해 주시기 바랍니다.
            </div>
          </WarningMessage>
          <Form>
            <FormItem>
              <FormItemTitle>아이디</FormItemTitle>

              <Input
                value={userId}
                isValidate={null}
                errorMessage=""
                placeholder={userId}
                disabled
                type="text"
                name="voda_user_id"
                autoComplete="off"
              />
            </FormItem>
            <FormItem>
              <FormItemTitle>비밀번호</FormItemTitle>

              <Input
                value={password}
                isValidate={null}
                errorMessage="비밀번호를 확인해주세요."
                disabled={false}
                type="password"
                name="voda_password"
                autoComplete="on"
                onChangeFunc={onChangePassword}
              />
            </FormItem>
            <FormItem>
              {loading[GET_CONFIRM_PASSWORD] ? (
                <Spinner />
              ) : (
                <FormButton
                  type="submit"
                  onClick={(event) => {
                    event.preventDefault();
                    onClickSubmitButton();
                  }}
                >
                  확인
                </FormButton>
              )}
            </FormItem>
          </Form>
        </ItemGrid>
      </ContainerGrid>
    </ContentsLayout>
  );
};

export default ConfirmPassword;
